import { CarrierType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class WorkOrderItemsDto{
    @ApiProperty()
    workOrderItemsId: number;

    @ApiProperty()
    workOrderId: number;

    @ApiProperty()
    baleId: number;

    @ApiProperty()
    quantity:number;
    
    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    updatedUser : string;

    @ApiProperty()
    @IsOptional()
    isActive : boolean;


}